<mat-expansion-panel togglePosition="before" displayMode="flat">
  <mat-expansion-panel-header>
    <mat-panel-title class="m-0">
      <span class="flex-fill"> Click actions</span>
      <mat-chip>{{selectedActions.length}}</mat-chip>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="ps-4 sub-actions-accordion">
    <mat-accordion togglePosition="before" displayMode="flat">
      <ng-container *ngFor="let action of selectedActions; let i=index">
        <mat-expansion-panel #panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title [class.fontsize]="workFlowGroup.get('workFlowName')?.value">
              <p class="label">{{ actionsLabel[action] | titlecase}}</p>
              <p class="value" *ngIf="panel.expanded">
                @if(action === widgetClickActions.workFlow){
                  {{(workFlowGroup.get('workFlowName')?.value ?? 'Select workflow') | titlecase}}
                }@else if(action === widgetClickActions.navigation){
                  {{(navigationGroup.get('pageName')?.value ?? 'Select page') | titlecase}}
                }@else if(action === widgetClickActions.lineItem){
                  {{(lineItemGroup.get('pageName')?.value ?? 'Select page') | titlecase}}
                }
              </p>
            </mat-panel-title>
            <div class="item-end control-buttons">
              @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
              <button mat-icon-button (click)="deleteAction(i,action,widget.widgetConfig?.actions);$event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </button>
            }
            </div>
          </mat-expansion-panel-header>

          @switch(action){
          <!-- Conditional workflow Action -->
          @case (widgetClickActions.conditionalWorkflow) {
            
            <ng-container *ngIf="workflowConditionalActions">
              <form [formGroup]="conditionalWorkFlowEditGroup">
                <div class="toggle-container custom-toggle-container">
                  <mat-slide-toggle class="w-100" formControlName="edit" checked><span class="font-add">Edit existing conditions</span></mat-slide-toggle>       
                </div>
                
                <mat-form-field appearance="outline" class="w-100" *ngIf="conditionalWorkFlowEditGroup.get('edit')?.value && resetSearchVar" >
                  <mat-label>Select Conditional workflow</mat-label>
                  <mat-select formControlName="search" (selectionChange)="setWorkFlowConditionalValue($event.value?.workflow)" [errorStateMatcher]="matInputError"  searchable [isObjectsList]="true" [displayKey]="'workflow_name'">
                    <ng-container *ngFor="let workflow of workflowConditionalActions;let idx=index">
                      <ng-container *ngFor="let workflowObj of workflow.workFlowList">
                        <mat-option *ngIf="workflow.action === workflowObj.workflow_id" [value]="{workflow:workflow,index:idx}">
                          {{ workflowObj.workflow_name }}
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </form>
              <ng-container *ngIf="conditionalWorkFlowEditGroup.get('edit')?.value && conditionalWorkFlowEditGroup.get('search')?.value">
                <div class="mat-form-field-container">
                       <ng-container [ngTemplateOutlet]="conditionalWorkflowForm"
                         [ngTemplateOutletContext]="{formGroup:workFlowConditionUpdatedGroup,conditionals:workflowConditions,conditionalWidgets:currentPageConditionalWidgetsUpdate}"></ng-container>
                 </div>
                 <div class="actions">
                  @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                  <button mat-stroked-button color="warn" 
                  (click)="confirmDeleteConditionalWorkFlowAction(conditionalWorkFlowEditGroup.get('search')?.value?.index)" >delete</button>
                   <button mat-flat-button color="primary"  [disabled]="workFlowConditionUpdatedGroup.invalid"
                   (click)="updateConditionalWorkflowAction(widgetClickActions.conditionalWorkflow, conditionalWorkFlowEditGroup.get('search')?.value?.index,workflowConditions)" >Update</button>
                  }
                 </div>
              </ng-container>
            </ng-container> 
            <ng-container *ngIf="!conditionalWorkFlowEditGroup.get('edit')?.value">
              <div class="mat-form-field-container mt-3">
                <ng-container [ngTemplateOutlet]="conditionalWorkflowForm"
                  [ngTemplateOutletContext]="{formGroup:workFlowConditionGroup,conditionals:NavigationConditionals,conditionalWidgets:currentPageConditionalWidgets}"></ng-container>
              </div>
              <div class="actions">
                @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                <button mat-stroked-button color="primary"
                  (click)="resetAction(action)">Cancel</button>
                <button mat-flat-button color="primary" color="primary" [disabled]="workFlowConditionGroup.invalid"
                  (click)="addConditionalWorkflowAction(widget.widgetConfig?.actions)">Add</button>
                }
              </div>
            </ng-container>
          }
          <!-- Workflow action -->
          @case(widgetClickActions.workFlow){
            <form [formGroup]="workFlowGroup" class="mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Select Entity</mat-label>
                <mat-select formControlName="entity"  searchable [isObjectsList]="true" [displayKey]="'entity_name'">
                  <ng-container *ngFor="let entity of entities">
                    <mat-option [value]='entity?.entity_id'>{{entity?.entity_name}}</mat-option>
                  </ng-container>
                </mat-select>
                <mat-error *ngIf="workFlowGroup.get('workFlowName')?.hasError('required')">Please select a
                  WorkFlow</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Select WorkFlow</mat-label>
                <mat-select formControlName="workFlowName" searchable [isObjectsList]="true" [displayKey]="'workflow_name'">
                  <ng-container *ngFor="let workflow of selectedEntityWorkflows">
                    <mat-option [value]="workflow.workflow_name">{{workflow.workflow_name | titlecase}}</mat-option>
                  </ng-container>
                </mat-select>
                <mat-error *ngIf="workFlowGroup.get('workFlowName')?.hasError('required')">Please select a
                  WorkFlow</mat-error>
              </mat-form-field>
            </form>
            <div class="actions">
              @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
              <button mat-stroked-button color="primary"
                (click)="deleteAction(i,action,widget.widgetConfig?.actions)">Cancel</button>
              <button mat-flat-button color="primary" color="primary" [disabled]="workFlowGroup.invalid"
                (click)="addWorkFlowAction(widget.widgetConfig?.actions)">Save</button>
              }
            </div>
          }
          <!-- Line item action -->
          @case(this.widgetClickActions.lineItem){
            <form [formGroup]="lineItemGroup" class="mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Select Page</mat-label>
                <mat-select formControlName="pageName" searchable [isObjectsList]="true" [displayKey]="'pageName'">
                  <ng-container *ngFor="let page of validPages">
                    <mat-option [value]="page.pageName">{{page.pageName | titlecase}}</mat-option>
                  </ng-container>
                </mat-select>
                <mat-error *ngIf="lineItemGroup.get('pageName')?.hasError('required')">Please select a page</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Select entity</mat-label>
                <mat-select formControlName="entityId" (selectionChange)="onEntitySelected($event)"  searchable 
                [isObjectsList]="true" [displayKey]="'entity_name'">
                  <ng-container *ngFor="let entity of entities" >
                    <mat-option [value]="entity.entity_id">{{entity.entity_name | titlecase}}</mat-option>
                  </ng-container>
                </mat-select>
                <mat-error *ngIf="lineItemGroup.get('entityId')?.hasError('required')">Please select a entity</mat-error>
              </mat-form-field>

              <mat-slide-toggle formControlName="bulk" (toggleChange)="lineItemGroup.get('table')?.patchValue(false)"  class="outline toggle-container custom-toggle-container">
                <span class="font-add">Bulk add</span>
              </mat-slide-toggle>
              <mat-slide-toggle formControlName="table" (toggleChange)="lineItemGroup.get('bulk')?.patchValue(false)" class="outline toggle-container custom-toggle-container">
                <span class="font-add">Table add</span>
              </mat-slide-toggle>
              <mat-slide-toggle formControlName="delete"  class="outline toggle-container custom-toggle-container">
                <span class="font-add">Enable delete line item</span>
              </mat-slide-toggle>

              <mat-form-field appearance="outline" [class.mat-no-hint]="lineItemGroup.get('referenceWidget')?.value" *ngIf="lineItemGroup.get('entityId')?.value">
                <mat-label>Reference widget</mat-label>
                <mat-select formControlName="referenceWidget" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                  <ng-container *ngFor="let widget of entityButtonWidgets" >
                    <mat-option [value]="widget.widgetId">{{widget.widgetLabel | titlecase}}</mat-option>
                  </ng-container>
                </mat-select>
                <button mat-icon-button matIconSuffix (click)="lineItemGroup.get('referenceWidget')?.reset()" *ngIf="lineItemGroup.get('referenceWidget')?.value"><mat-icon>close</mat-icon></button>
              </mat-form-field>
               <mat-slide-toggle *ngIf="lineItemGroup.get('referenceWidget')?.value" formControlName="displayLineItems"  class="outline toggle-container custom-toggle-container">
                <span class="font-add">Display lineItems</span>
              </mat-slide-toggle>
              <mat-accordion togglePosition="before" displayMode="flat">
              <mat-expansion-panel class="sub-panel" togglePosition="before" displayMode="flat">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="panal" style="display: flex;">
                      <div class="panal-title">Card Design</div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="d-flex flex-column gap-3">
                  <div class="mb-inner-pennal">
                    <h6 class="titl">LHS</h6>
                    <div formArrayName="lhsItems" class="d-flex flex-column gap-2 mb-2">
                      <ng-container *ngFor="let item of lhsItems.controls; let leftIndex = index">
                        <div [formGroupName]="leftIndex" class="d-flex gap-2 align-items-center">
                          <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Select Field</mat-label>
                            <mat-select formControlName="widgetId" disableRipple  searchable [isObjectsList]="true" 
                            [displayKey]="'widgetLabel'">
                              <mat-option *ngFor="let option of getFilteredOptions(leftIndex,'lhs')" [value]="option.widgetId">
                                {{ option?.widgetLabel ? option?.widgetLabel : '' }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div class="item-end control-buttons">
                            @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                            <button mat-icon-button color="warn" (click)="removeLhsFieldsInCard(leftIndex)" aria-label="Example icon button with a menu icon" class="control-buttons">
                              <mat-icon class="control-buttons">delete</mat-icon>
                            </button>
                          }
                          </div>
                        </div>
                        <mat-error *ngIf="filterWidgetList.length==0 && isLhsclicked">No attributes found in the entity</mat-error>
                      </ng-container>
                    </div>
                    @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                    <button mat-stroked-button (click)="addLhsFieldsInCard()" class="w-100 " color="primary" [disabled]="(lhsItems.controls?.length ?? 0) + (rhsItems.controls?.length ?? 0) === filterWidgetList?.length">
                      <mat-icon>add</mat-icon> Add Field</button>
                    }
                  </div>
                  <div class="mb-inner-pennal">
                    <h6 class="titl">RHS</h6>
                    <div formArrayName="rhsItems" class="d-flex flex-column gap-2 mb-2">
                      <ng-container *ngFor="let item of rhsItems.controls; let rightIndex = index">
                        <div [formGroupName]="rightIndex" class="d-flex gap-2 align-items-center">
                          <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Select Field</mat-label>
                            <mat-select  searchable [isObjectsList]="true" [displayKey]="'widgetLabel'"                 formControlName="widgetId"  disableRipple>
                              <mat-option *ngFor="let option of getFilteredOptions(rightIndex,'rhs')" [value]="option.widgetId">
                                {{ option?.widgetLabel ? option?.widgetLabel : '' }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div class="item-end control-buttons">
                            @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                            <button mat-icon-button color="warn" (click)="removeRhsFieldsInCard(rightIndex)" aria-label="Example icon button with a menu icon">
                              <mat-icon>delete</mat-icon>
                            </button>
                          }
                          </div>
                        </div>
                        <mat-error *ngIf="filterWidgetList.length==0 && isRhsclicked">No attributes found in the entity</mat-error>
                      </ng-container>
                    </div>
                    @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                    <button mat-stroked-button (click)="addRhsFieldsInCard()" class="w-100" color="primary" [disabled]="(lhsItems.controls?.length ?? 0) + (rhsItems.controls?.length ?? 0) === filterWidgetList?.length">
                      <mat-icon>add</mat-icon> Add Field</button>
                    }
                  </div>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel class="mt-2 sub-panel" (opened)="defaultValuesSetter()" *ngIf="lineItemGroup.get('entityId')?.value" togglePosition="before" displayMode="flat">
                <mat-expansion-panel-header>
                  <mat-panel-title> Default values</mat-panel-title>
                </mat-expansion-panel-header>
                <div formArrayName="defaultValues">
                  <div *ngFor="let item of lineItemdefaultValues.controls; let i = index" [formGroupName]="i" class="line-item">
                    <!-- Widget value dropdown -->
                    <mat-form-field appearance="outline" class="w-100" *ngIf="item.get('widget')?.value as widgetOption">
                      <mat-label>{{ widgetOption.widget.widgetLabel}}</mat-label>
                      <mat-select formControlName="value" placeholder="Select value">
                        <mat-option *ngFor="let value of widgetOption.options" [value]="value.label">
                          {{ value.label }}
                        </mat-option>
                        <mat-option [value]="null" disabled *ngIf="widgetOption?.options?.length < 1">No values found</mat-option>
                      </mat-select>
                      <button mat-icon-button matIconSuffix (click)="removeDefaultField(i,widgetOption)"><mat-icon>close</mat-icon></button>
                    </mat-form-field>
                  </div>
                </div>
                @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                  <lib-searchable-mat-menu *ngIf="lineItemGroup.valid"  [items]="widgetsforDefaultValues"
                  [displayProperty]="'widget.widgetLabel'"
                  [filterProperty]="'widget.widgetLabel'"
                  [menuButtonLabel]="'Add Widget'"
                  (itemSelected)="addDefaultFields($event.selectedItem,$event.selectedIndex)" ></lib-searchable-mat-menu>
                }
              </mat-expansion-panel>

              <!-- validations  -->
              <mat-expansion-panel class="mt-2 sub-panel" (opened)="validationsSetter()" *ngIf="lineItemGroup.get('entityId')?.value" togglePosition="before" displayMode="flat">
                <mat-expansion-panel-header>
                  <mat-panel-title> Validations</mat-panel-title>
                </mat-expansion-panel-header>
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Error message</mat-label>
                    <input type="text" matInput formControlName="validationErrorMessage">
                  </mat-form-field>

                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="validationType">
                      @for(option of  ["entity","manual"]; track option){
                        <mat-option [value]="option">{{ option | titlecase}}</mat-option>
                        }
                    </mat-select>
                  </mat-form-field>

                  @if(lineItemGroup.get('validationType')?.value === 'entity') {
                    <div formGroupName="validationEntity">
                      <mat-form-field class="w-100" appearance="outline" *ngIf="lineItemGroup.get('validationType')?.value === 'entity'">
                        <mat-label>select Entity</mat-label>
                        <mat-select formControlName="foreignEntityId" >
                          @for(entity of  entities; track entity.entity_id){
                            <mat-option [value]="entity.entity_id">{{ entity.entity_name | titlecase}}</mat-option>
                            }
                    </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>label</mat-label>
                      <mat-select formControlName="label" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                        @for( widget of  entitiesWidgetsMaping[lineItemGroup.get('validationEntity')?.get('foreignEntityId')?.value]; track widget.widgetId){
                          <mat-option [value]="widget.widgetId">{{ widget.widgetLabel | titlecase}}</mat-option>
                          }
                        </mat-select>
                    </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>key</mat-label>
                          <mat-select formControlName="key"  searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                            @for( widget of  entitiesWidgetsMaping[lineItemGroup.get('validationEntity')?.get('foreignEntityId')?.value]; track widget.widgetId){
                              <mat-option [value]="widget.widgetId">{{ widget.widgetLabel | titlecase}}</mat-option>
                              }
                            </mat-select>
                        </mat-form-field>
                 

                         <!-- filters  -->
                        <lib-widget-data-filters [group]="validationEntityGroup" [applicationId]="applicationId" [entities]="entities" [filterControlName]="'filters'" [listOfWidgetsOfEntity]="entitiesWidgetsMaping[lineItemGroup.get('validationEntity')?.get('foreignEntityId')?.value]" [filterValues]="this.filterValues ?? []"></lib-widget-data-filters>

                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Based on</mat-label>
                        <mat-select formControlName="basedOn" multiple searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                          @for( widget of  entitiesWidgetsMaping[lineItemGroup.get('entityId')?.value]; track widget.widgetId){
                            <mat-option [value]="widget.widgetId">{{ widget.widgetLabel | titlecase}}</mat-option>
                            }
                          </mat-select>
                      </mat-form-field>
                    </div>
                  }

                  @if(lineItemGroup.get('validationType')?.value === 'manual'){
                    <mat-accordion togglePosition="before" displayMode="flat">
                <div formArrayName="validations">
                  <div *ngFor="let item of lineItemValidations.controls; let i = index" [formGroupName]="i" class="line-item">
                    
                     <ng-container  *ngIf="item.get('widget')?.value as widgetOption">
                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title> {{ widgetOption.widget.widgetLabel}}</mat-panel-title>
                        </mat-expansion-panel-header>
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Value</mat-label>
                            <input type="text" matInput formControlName="value">
                            
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>count</mat-label>
                           <input type="number" matInput formControlName="count" [min]="0">
                           <mat-error>Please enter a valid value</mat-error>
                          </mat-form-field>
                          <div class="float-end validations-button">
                            @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                            <button mat-flat-button color="warn"
                            (click)="removeValidationField(i,widgetOption)">Remove</button>
                            }
                          </div>
                        </mat-expansion-panel>
                      </ng-container>
                      
                    </div>
                  </div>
                </mat-accordion>
                }
                @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                  <lib-searchable-mat-menu *ngIf="lineItemGroup.valid"  [items]="widgetsforValidations"
                  [displayProperty]="'widget.widgetLabel'"
                  [filterProperty]="'widget.widgetLabel'"
                  [menuButtonLabel]="'Add Widget'"
                  (itemSelected)="addValidationFields($event.selectedItem,$event.selectedIndex)" ></lib-searchable-mat-menu>
                }
              </mat-expansion-panel>
              </mat-accordion>
            </form>
            <div class="actions">
              @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
              <button mat-stroked-button color="primary"
                (click)="deleteAction(i,action,widget.widgetConfig?.actions)">Cancel</button>
              <button mat-flat-button color="primary" color="primary" [disabled]="lineItemGroup.invalid"
                (click)="addLineItemAction(widget.widgetConfig?.actions)">Save</button>
              }
            </div>
          }
          <!-- Navigarion action -->
          @case(widgetClickActions.navigation){
            <form [formGroup]="navigationGroup" class="mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Select Page</mat-label>
                <mat-select formControlName="pageName" #defaultNavigation  searchable [isObjectsList]="true"         [displayKey]="'pageName'">
                  @for(page of validPages; track page){
                  <mat-option [value]="page.pageName">{{page.pageName | titlecase}}</mat-option>
                  }
                </mat-select>
                <mat-hint *ngIf="defaultNavigation.focused && validPages.length < 1">Please add pages</mat-hint>
                <mat-error *ngIf="navigationGroup.get('pageName')?.hasError('required')">Please select a page</mat-error>
              </mat-form-field>
            </form>
            <div class="actions">
              @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
              <button mat-stroked-button color="primary"
                (click)="deleteAction(i,action,widget.widgetConfig?.actions)">Cancel</button>
              <button mat-flat-button color="primary" color="primary" [disabled]="navigationGroup.invalid" (click)="addDefaultNavigationAction()">Save</button>
              }
            </div>
          }
          <!--  Conditional navigation action -->
          @case(widgetClickActions.conditionalNavigation){
            <ng-container *ngIf="conditionalActions">
              <mat-accordion togglePosition="before" displayMode="flat">
                <ng-container *ngFor="let item of conditionalActions; let idx = index ">
                  <mat-expansion-panel (opened)="setConditionalValue(item)">
                    <mat-expansion-panel-header class="mat-list-item" mat-ripple>
                      <mat-panel-title>
                        <div style="color:white;"> <ng-container *ngFor="let page of validPages">
                            <p *ngIf="item.action  == page.pageId" style="color:white;">{{page.pageName}}</p>
                          </ng-container></div>
                      </mat-panel-title>
                      <div class="item-end control-buttons">
                        @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                        <button mat-icon-button (click)="confirmDeleteConditionalNavigationAction(idx,widget.widgetConfig?.actions);$event.stopPropagation()">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                      </div>
                    </mat-expansion-panel-header>
                    <ng-container [ngTemplateOutlet]="conditionalNavigationForm"
                      [ngTemplateOutletContext]="{formGroup:conditionalActionUpdatedGroup,conditionals:currentConditions,conditionalWidgets:currentPageConditionalWidgetsUpdate}"></ng-container>
                    <div class="actions">
                      <button mat-flat-button color="primary" color="primary"
                        (click)="updateConditionalActions(widgetClickActions.conditionalNavigation, idx,currentConditions)">Update</button>
                    </div>
                  </mat-expansion-panel>
                </ng-container>
              </mat-accordion>
            </ng-container>

            <div class="mat-form-field-container mt-2">
              <form [formGroup]="conditionalActionGroup">
                <ng-container [ngTemplateOutlet]="conditionalNavigationForm"
                  [ngTemplateOutletContext]="{formGroup:conditionalActionGroup,conditionals:NavigationConditionals,conditionalWidgets:currentPageConditionalWidgets}"></ng-container>
                <div class="actions">
                  @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                  <button mat-stroked-button color="primary"
                    (click)="deleteAction(i,action,widget.widgetConfig?.actions)">Cancel</button>
                  <button mat-flat-button color="primary" color="primary" [disabled]="conditionalActionGroup.invalid"
                    (click)="addCondiotionAction()">Add</button>
                  }
                </div>
              </form>
            </div>
          }
          <!-- Submit -->
          @case(widgetClickActions.submit){
          <form [formGroup]="previewGroup">
            <div class="app-name mt-2 m-lg-2">
              <h4 class="title">Preview</h4>
              <mat-slide-toggle formControlName="preview" color="primary"></mat-slide-toggle>
            </div>
            <div class="actions">
              @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
              <button mat-stroked-button color="primary"
                (click)="deleteAction(i,action,widget.widgetConfig?.actions)">Cancel</button>
              <button mat-flat-button color="primary"  (click)="addSubmitAction()">Save</button>
              }
            </div>
          </form>
          }
          <!-- request -->
           @case(widgetClickActions.request){
            <form [formGroup]="requestGroup">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>select Api</mat-label>
                <mat-select formControlName="api" searchable [isObjectsList]="true" [displayKey]="'apiName'">
                  @for(api of userconfiguredApis.apis;track api){
                    <mat-option [value]="api.apiId">{{api.apiName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div formArrayName="variables" *ngIf="apiVariables.length > 0">
                <h5>Variables</h5>
                <!-- Loop through each variable in the FormArray -->
                <div *ngFor="let variable of apiVariables.controls; let i = index" [formGroupName]="i" class="variable-group">
              
                  <!-- Value field -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{variable.get('name')?.value}}</mat-label>
                    <mat-select formControlName="value" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                      @for(widget of currentPageWidgets;track widget){
                        <mat-option [value]="widget.widgetId">{{widget.widgetLabel}}</mat-option>
                      }
                    </mat-select>
                    <mat-error *ngIf="variable.get('value')?.hasError('required')">Value is required</mat-error>
                  </mat-form-field>
                </div>
              </div>

                <button mat-flat-button color="primary" class="w-100" type="button"
                (click)="makeApiCall(requestGroup.get('api')?.value)">Fetch api responce</button>

              <mat-form-field class="w-100 mt-2" appearance="outline" >
                <mat-label>select Keys</mat-label>
                <mat-select formControlName="displayKeys" multiple  searchable [isObjectsList]="true"               [displayKey]="'label'">
                  @for(apikey of apiKeyPaths;track apiKeyPaths){
                    <mat-option [value]="apikey.path">{{apikey.label | titlecase}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

            </form>
            <div class="actions">
              @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
              <button mat-stroked-button color="primary"
                (click)="deleteAction(i,action,widget.widgetConfig?.actions)">Cancel</button>
              <button mat-flat-button color="primary" color="primary" [disabled]="requestGroup.invalid"
                (click)="addorEditRequestAction(widget.widgetConfig?.actions)">Save</button>
              }
            </div>
           }
          }
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
    <!-- Add action menu and button -->
     @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
       <div class="mat-form-field-container mt-3" *ngIf="buttonActions.length > 0">
         <form [formGroup]="actionForm">
           <mat-form-field class="w-100 mt-3" appearance="outline">
             <mat-label>Select Action Type</mat-label>
             <mat-select formControlName="selectedAction"  searchable [isObjectsList]="true" [displayKey]="'label'">
               <mat-option *ngFor="let option of buttonActions" [value]="option.action"
                 (click)="addAction(actionForm.get('selectedAction')?.value)">
                 {{ option.label | titlecase }}</mat-option>
             </mat-select>
           </mat-form-field>
         </form>
       </div>
     }
  </div>
</mat-expansion-panel>

<!-- Add AdditionaField Template  -->
<ng-template #actionConditions let-conditionals="conditionals" let-conditionalWidgets="conditionalWidgets">
  <div class="mat-form-field-container">
    <p class="label" *ngIf="conditionals && conditionals.length > 0">Conditions</p>
    <ng-container *ngFor="let condition of conditionals;let itemIndex = index">
      <mat-chip-set #chipGrid aria-label="manual values" >
        @for (option of condition.manual ?? []; track option) {
          <mat-chip color="primary" *ngIf="!checkOptionExistsInConditionOptions(option,condition.options)">
            {{option}}
            <button matChipRemove [attr.aria-label]="'remove ' + option.label" (click)="removeManualValue(option,condition.manual ?? [])">  
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        }
      </mat-chip-set>
      <mat-form-field appearance="outline" class="mt-1">
        <mat-label>{{condition.key.widgetLabel}}</mat-label>
        <mat-select [(ngModel)]="condition.values" multiple searchable [isObjectsList]="true" [displayKey]="'label'">
          <mat-option *ngFor="let option of condition.options" [value]="option.label">
            {{ option.label }}</mat-option>
        </mat-select>
        <mat-icon (click)="delectChipGridItem(itemIndex,condition,conditionals,conditionalWidgets)"
          matSuffix>close</mat-icon>
          <mat-hint class="w-100 mb-2" #matManualHint [hidden]="condition.key.widgetType !== widgetTypes.dropdown" ><mat-slide-toggle class="ps-5"  #manualToggle labelPosition="before" >Add Manual</mat-slide-toggle></mat-hint>
      </mat-form-field>
      @if(condition.key.widgetType === widgetTypes.dropdown ){
        <mat-form-field *ngIf="manualToggle?.checked" appearance="outline" class="mt-1">
          <mat-label>Manual value</mat-label>
          <input type="text" #manualInput matInput >
          <mat-icon (click)="addManualValue(manualInput.value,condition,manualInput)"
          matSuffix>add</mat-icon>
        </mat-form-field>
      }
    </ng-container>
  </div>
  <ng-container>
    <lib-searchable-mat-menu  *ngIf="conditionalWidgets.length > 0"  [items]="conditionalWidgets"
    [displayProperty]="'widgetLabel'"
    [filterProperty]="'widgetLabel'"
    [menuButtonLabel]="'Add Conditional Field'"
    (itemSelected)="addFieldCondition($event.selectedIndex,$event.selectedItem,conditionals,conditionalWidgets)" ></lib-searchable-mat-menu>
  </ng-container>
</ng-template>

<!-- Conditional workflow action template  -->
<ng-template #conditionalWorkflowForm let-formGroup="formGroup" let-conditionals="conditionals" let-conditionalWidgets="conditionalWidgets">
  <form [formGroup]="formGroup">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Select Entity</mat-label>
      <mat-select formControlName="entity" [errorStateMatcher]="matInputError" searchable [isObjectsList]="true" [displayKey]="'entity_name'">
        <ng-container *ngFor="let entity of entities">
          <mat-option [value]='entity?.entity_id'>{{entity?.entity_name}}</mat-option>
        </ng-container>
      </mat-select>
      <mat-error *ngIf="formGroup?.get('entity')?.hasError('required')">{{entities.length > 0 ? 'Please select a Entity' : 'No entities found, please add an entity'}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Select WorkFlow</mat-label>
      <mat-select formControlName="workFlowId" [errorStateMatcher]="matInputError" searchable [isObjectsList]="true" [displayKey]="'workflow_name'">
          <ng-container *ngFor="let workflow of selectedEntityWorkflows">
            <mat-option [value]="workflow.workflow_id">{{workflow.workflow_name | titlecase}}</mat-option>
          </ng-container>
      </mat-select>
      <mat-error *ngIf="formGroup.get('workFlowId')?.hasError('required')"> 
        @if(formGroup.get('entity')?.invalid){
          {{"Please select an entity first" | titlecase}}
        }@else if (selectedEntityWorkflows?.length > 0) {
          {{"Please select a WorkFlow" | titlecase}}
        }@else{
          {{"Entity has no workflows." | titlecase}}
        }

      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Select parameters</mat-label>
      <mat-select formControlName="parameters" multiple searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
        <ng-container *ngFor="let widget of currentPageWidgets">
          <mat-option [value]="widget.widgetId">{{widget.widgetLabel | titlecase}}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <!-- Conditional fields -->
    <ng-container [ngTemplateOutlet]="actionConditions"
      [ngTemplateOutletContext]="{conditionals:conditionals,conditionalWidgets:conditionalWidgets}"></ng-container>
  </form>
</ng-template>

<!-- Conditional Navigation Action  template-->
<ng-template #conditionalNavigationForm let-formGroup="formGroup" let-conditionals="conditionals"
  let-conditionalWidgets="conditionalWidgets">
  <form [formGroup]="formGroup">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Go To</mat-label>
      <mat-select formControlName="pageName" searchable [isObjectsList]="true" [displayKey]="'pageName'">
        <ng-container *ngFor="let page of validPages">
          <mat-option [value]="page.pageId">{{page.pageName | titlecase}}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Select parameters</mat-label>
      <mat-select formControlName="parameters" multiple searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
        <ng-container *ngFor="let widget of currentPageWidgets">
          <mat-option [value]="widget.widgetId">{{widget.widgetLabel | titlecase}}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </form>
  <!-- Conditional fields -->
  <ng-container [ngTemplateOutlet]="actionConditions"
    [ngTemplateOutletContext]="{conditionals:conditionals,conditionalWidgets:conditionalWidgets}"></ng-container>
</ng-template>

<ng-template #confirmationDialog let-data="$implicit">
  <h2 mat-dialog-title>Delete Confirmation</h2>
  <mat-dialog-content>
    {{ data?.message }}
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex">
    @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
    <button mat-stroked-button [mat-dialog-close]="false">Cancel</button>
    <span class="flex-fill"></span>
    <button mat-flat-button color="warn" [mat-dialog-close]="true">Delete</button>
    }
  </mat-dialog-actions>
</ng-template>


